import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { filter, uniqBy } from 'lodash';
import Layout from '../../../templates/forms/Layout';
import { loadConditionParts } from '../../../../../../actions';
import ConditionFooter from '../../../templates/forms/condition/splats/footer';
import Icon from '../../../ui/icons';
import Loader from '../../../ui/loader';
import { CYAN_01, GREY_07 } from '../../../../constants/colors';
import ConfirmationModal from '../../../modals/ConfirmationModal';
import '../../../../styles/form/condition.css';
class Parts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: !!props.location.state.edit,
      area: '',
      loaded: false,
      loadingDataSource: [{ description: 'Loading...' }],
      menuItems: ['Standard'],
      selectedMenuItem: 0,
      searchText: '',
      openErrorModal: false,
      message: '',
    };
  }

  componentDidMount() {
    this.loadItems();
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.loaded && nextProps.condition.parts.amStatus === 'Success') {
      this.loadItems();
    }
  }

  loadItems() {
    const area = this.props.location.state.condition.area;
    const menuItems = (this.props.crTypes.values || [])
      .map(value => value.name)
      .filter(name => name && String(name).toLowerCase() !== 'standard')
      .concat('Standard');

    this.setState(
      {
        area,
        menuItems,
        loaded: false,
      },
      () => {
        this.props
          .loadConditionParts(
            area,
            this.state.menuItems[this.state.selectedMenuItem]
          )
          .then(({ response }) => {
            if (response.amStatus === 'Success') {
              this.setState({ loaded: true });
            } else if (response.amStatus === 'Error') {
              this.setState({
                message: `Unable to load data. Error: ${response.amMessage}`,
                openErrorModal: true,
              });
            }
          })
          .catch(error => console.error(error));
      }
    );
  }

  handleClick = item => {
    const { isEdit } = this.state;
    const { area, selectedRow } = this.props.location.state.condition;
    const edit = this.props.location.state.edit;
    const checked = edit && item.description === edit.part ? true : false;
    this.props.navigate(
      isEdit ? '/core/conditionReview/damage' : '/core/condition/damage',
      {
        state: {
          condition: {
            area: area,
            part: item.description,
            selectedRow: selectedRow,
          },
          edit,
          checked,
          selectedCrType: this.state.menuItems[this.state.selectedMenuItem],
        },
      }
    );
  };

  handleMenuItemsClick(index) {
    this.setState(
      {
        selectedMenuItem: index,
        loaded: false,
      },
      this.loadItems()
    );
  }

  filterList(searchText, list) {
    const text = searchText.toLowerCase();
    return filter(list, v => {
      const val = v.description.toLowerCase();
      return val.search(text) !== -1;
    });
  }

  render() {
    const {
      menuItems,
      selectedMenuItem,
      searchText,
      loaded,
      isEdit,
    } = this.state;

    let parts = null;
    if (parts == null || !this.state.loaded) {
      parts = this.state.loadingDataSource;
    }
    if (this.props.condition && this.props.condition.parts) {
      parts = uniqBy(
        this.props.condition.parts && this.props.condition.parts.values,
        e => e.description
      );
    }
    if (searchText !== '') {
      parts = this.filterList(searchText, parts);
    }

    const edit = this.props.location.state.edit;

    return (
      <Layout>
        <ConfirmationModal
          open={this.state.openErrorModal}
          close={() => this.setState({ openErrorModal: false, area: '' })}
          action={() => this.loadItems()}
          title="Error"
          body={this.state.message}
          confirmBtnTxt="Try Again"
          iconName="CircledExclamationmark"
        />
        <div className="flex justify-between h-100">
          <div className="form-container w-100">
            <div>
              <div>
                <div className="form-header form-sub-section">
                  <div
                    onClick={() =>
                      this.props.navigate(
                        isEdit ? '/core/conditionReview' : '/core/condition',
                        {
                          state: {
                            condition: {
                              selectedRow: this.props.location.state.condition
                                .selectedRow,
                            },
                          },
                        }
                      )
                    }
                  >
                    <Icon name="LeftArrow" size={20} color={CYAN_01} />
                    {isEdit ? 'Condition Review' : 'Condition'}
                  </div>
                </div>
                <div className="form-body-container form-sub-section">
                  <div className="form-body form-sub-section">
                    <div className="form-sub-section-title">
                      <div>Parts</div>
                    </div>
                    <div
                      className="search-container"
                      style={{ borderRadius: '10px' }}
                    >
                      <input
                        type="text"
                        value={searchText}
                        onChange={e =>
                          this.setState({ searchText: e.target.value })
                        }
                        className="search-box"
                        placeholder="Search"
                      />
                    </div>
                    {!loaded ? (
                      <Loader className="conditions-loader flex justify-center pt-4" />
                    ) : null}
                    {menuItems.length > 1 &&
                      loaded && (
                        <div>
                          <div className="mb-3">CR Types:</div>
                          <div className="splats">
                            {menuItems.map((item, index) => {
                              return (
                                <div
                                  key={'crType-' + index}
                                  className={`splat-type ${selectedMenuItem ===
                                    index && 'splat-type-selected'}`}
                                  onClick={() =>
                                    this.handleMenuItemsClick(index)
                                  }
                                >
                                  {item}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    {loaded &&
                      parts.map((item, index) => {
                        const checked = edit && item.description === edit.part;
                        return (
                          <div
                            key={'parts-' + index}
                            className="form-section-navigation-card"
                            onClick={() => this.handleClick(item)}
                          >
                            <span>{item.description}</span>
                            {checked ? (
                              <Icon name="Checkmark" size={17} />
                            ) : (
                              <Icon
                                name="ChevronRight"
                                size={20}
                                color={GREY_07}
                              />
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
            <ConditionFooter isSaveDisabled={true} isEdit={isEdit} />
          </div>
        </div>
      </Layout>
    );
  }
}

Parts.propTypes = {
  loadConditionParts: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { condition, crTypes, item } = state.core;
  const { loadingBar } = state;
  return { condition, crTypes, loadingBar, item };
};

export default connect(
  mapStateToProps,
  {
    loadConditionParts,
  }
)(Parts);
